import { render, staticRenderFns } from "./btn-document-download.vue?vue&type=template&id=4ea7d181&scoped=true&"
import script from "./btn-document-download.vue?vue&type=script&lang=js&"
export * from "./btn-document-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea7d181",
  null
  
)

export default component.exports